import { InjectionToken } from '@angular/core';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.General {
        interface AppData {
            connect?: { [serviceName: string]: boolean };
        }
    }
}

export namespace NUi {
    export const DEFAULT_OPTIONS: IModuleOptions = {
        href: {
            reloadPage: false
        },
        date: {
            format: 'shortDate'
        },
        price: {
            precision: 'auto',
            thousandSeparator: '',
            decimalSeparator: (1.1).toFixed(1).replace(/1/g, ''),
            useHtml: false,
            symbolAfterPrice: false,
            symbolSeparator: '',
            freeLabelText: 'FREE'
        },
        filter: {
            range: {
                step: 25
            }
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_UI_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        href: {
            reloadPage: boolean;
        };

        date: {
            format: string;
        };

        price: {
            /**
             * Precision
             */
            precision: 1 | 2 | 'auto';
            /**
             * Thousands separator
             */
            thousandSeparator: string;
            /**
             * Decimal separator
             */
            decimalSeparator: string;
            /**
             * Use html when creating price string
             */
            useHtml: boolean;
            /**
             * Specify the location of the currency symbol
             */
            symbolAfterPrice: boolean;
            /**
             * Separator between the price and the currency symbol
             */
            symbolSeparator: string;
            /**
             * Displayed text for 0 value if useFreeLabel is true
             */
            freeLabelText: string;
            /**
             * If set it will be used to set how we want prices displayed initially
             */
            initDisplayTaxWith?: boolean;
            /**
             * If set we won't check local storage for initial value
             */
            initDisplayTaxFromConfig?: boolean;
        };
        filter: {
            range: {
                step: number;
            };
        };
    }
}

declare module '@df/core/df-core.config' {
    export interface IDfConfig {
        ui: {
            shell: {
                path: string;
                bg: string;
            };
        };
    }
}
